import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';

const exportedObject = { reducer, selectors, actions };

export default exportedObject;
